module Client.Components.SupplyOrderInfos

open Client
open Shared
open global.Elmish
open Fable.Core.JsInterop
open Feliz
open Feliz.MaterialUI
open Thoth.Fetch
open Fable.Core.JS
open Feliz.SweetAlert
open Feliz.UseElmish
open Fetch

let viewQuoteDetail = React.functionComponent (fun (inputProps: {| token : string; i : int; equipmentNumber : string; quoteDetail : Shared.SupplyQuoteDetail; customerContactName : string option; customerContactEmail : string; |}) ->
  let classes = Styles.useStyles()
  let buttonProgressIndicator =
    Mui.circularProgress [
      prop.className classes.buttonProgress
      prop.size 24
    ]
  Mui.listItem [
    listItem.alignItems.flexStart
    listItem.children [
      Mui.listItemText [
        listItemText.primary inputProps.quoteDetail.QuoteNumber
        listItemText.secondary [
          Html.br []
          Mui.typography [
            typography.display.inline'
            typography.children "Request Date: "
          ]
          Mui.typography [
            typography.display.inline'
            typography.variant.body2
            typography.children (inputProps.quoteDetail.QuoteDate.ToString("MM/dd/yyyy"))
          ]
          Html.br []
          Mui.typography [
            typography.display.inline'
            typography.children (sprintf "Description: ")
          ]
          Mui.typography [
            typography.display.inline'
            typography.variant.body2
            typography.children inputProps.quoteDetail.Description
          ]
          Html.br []
          Mui.typography [
            typography.display.inline'
            typography.children (sprintf "Quantity: ")
          ]
          Mui.typography [
            typography.display.inline'
            typography.variant.body2
            typography.children (sprintf "%2f" inputProps.quoteDetail.Quantity)
          ]
        ]
      ]
    ]
  ]
)

let viewShipmentInfo = React.functionComponent (fun (inputProps: {| token : string; orderId : int; abandonComponent : unit -> unit; |}) ->
      Mui.dialog [
      dialog.open' true
      dialog.scroll.body
      dialog.onBackdropClick (fun _ -> inputProps.abandonComponent ())
      dialog.children [
        Mui.dialogTitle "Shipments"
        Mui.dialogContent [
          Components.Shipments.view {| token = inputProps.token; orderId = inputProps.orderId; |}
        ]
        Mui.dialogActions [
          Mui.button [
            button.fullWidth true
            button.variant.contained
            button.color.primary
            prop.onClick (fun _ -> inputProps.abandonComponent ())
            button.children "Close"
          ]
        ]
      ]
    ]
)
let viewOrderDetail = React.functionComponent (fun (inputProps: {| token : string; i : int; equipmentNumber : string; orderDetail : Shared.SupplyOrderDetail; customerContactName : string option; customerContactEmail : string; |}) ->
  let classes = Styles.useStyles()
  let showShipmentInfo, setShowShipmentInfo = React.useState false
  let buttonProgressIndicator =
    Mui.circularProgress [
      prop.className classes.buttonProgress
      prop.size 24
    ]

  Html.div [
    if showShipmentInfo
    then viewShipmentInfo {| token = inputProps.token; orderId = inputProps.orderDetail.OrderId; abandonComponent = (fun _ -> setShowShipmentInfo false); |}
    else Html.none
    Mui.listItem [
      listItem.alignItems.flexStart
      listItem.children [
        Mui.listItemText [
          listItemText.primary inputProps.orderDetail.OrderNumber
          listItemText.secondary [
            Html.br []
            Mui.typography [
              typography.display.inline'
              typography.children "Order Date: "
            ]
            Mui.typography [
              typography.display.inline'
              typography.variant.body2
              typography.children (inputProps.orderDetail.OrderDate.ToString("MM/dd/yyyy"))
            ]
            Html.br []
            Mui.typography [
              typography.display.inline'
              typography.children (sprintf "Description: ")
            ]
            Mui.typography [
              typography.display.inline'
              typography.variant.body2
              typography.children inputProps.orderDetail.Description
            ]
            Html.br []
            Mui.typography [
              typography.display.inline'
              typography.children (sprintf "Quantity: ")
            ]
            Mui.typography [
              typography.display.inline'
              typography.variant.body2
              typography.children (sprintf "%2f" inputProps.orderDetail.Quantity)
            ]
            Html.br []
            Mui.typography [
              typography.display.inline'
              typography.children (sprintf "Shipped: ")
            ]
            Mui.typography [
              typography.display.inline'
              typography.variant.body2
              typography.children (sprintf "%2f" inputProps.orderDetail.Shipped)
            ]
            if inputProps.orderDetail.Shipped > 0m
            then
              Mui.button [
                prop.type'.button
                button.fullWidth true
                button.variant.contained
                button.color.default'
                button.children "Lookup Shipments"
                prop.onClick (fun e ->
                  e.preventDefault ()
                  setShowShipmentInfo true
                )
              ]

          ]
        ]
      ]
    ]
  ]

)

let viewOrderDetails = React.functionComponent (fun (inputProps: {| token : string; equipmentNumber : string; orderDetails : Shared.SupplyOrderDetail list; customerContactName : string option; customerContactEmail : string; |}) ->
  Mui.list [
    prop.width 100
    list.children [
      yield! inputProps.orderDetails
      |> List.mapi (fun i orderDetail ->
        [
            viewOrderDetail {| token = inputProps.token; equipmentNumber = inputProps.equipmentNumber; orderDetail = orderDetail; i = i; customerContactName = inputProps.customerContactName; customerContactEmail = inputProps.customerContactEmail; |}
            if inputProps.orderDetails.Length > 1 && (i+1) < inputProps.orderDetails.Length then
              Mui.divider []
        ]
      )
      |> List.concat
    ]
  ]
)
let view = React.functionComponent (fun (inputProps: {| token : string; equipmentNumber : string; orderInfos : Shared.SupplyOrderInfos; customerContactName : string option; customerContactEmail : string; |}) ->

  Mui.grid [
    grid.container true
    grid.direction.column
    grid.spacing._2
    grid.children [
      Mui.grid [
        grid.item true
        grid.children [
          Mui.typography [
            typography.variant.h6
            typography.children "Requests pending approval"
          ]
        ]
      ]
      Mui.grid [
        grid.item true
        grid.children [
          if inputProps.orderInfos.SupplyQuoteDetails.Length = 0
          then
            Mui.typography [
              typography.variant.body2
              typography.children "No pending requests found."
            ]
          else
            Mui.list [
              prop.width 100
              list.children [
                yield! inputProps.orderInfos.SupplyQuoteDetails
                |> List.mapi (fun i quoteDetail ->
                  [
                      viewQuoteDetail {| token = inputProps.token; equipmentNumber = inputProps.equipmentNumber; quoteDetail = quoteDetail; i = i; customerContactName = inputProps.customerContactName; customerContactEmail = inputProps.customerContactEmail; |}
                      if inputProps.orderInfos.SupplyQuoteDetails.Length > 1 && (i+1) < inputProps.orderInfos.SupplyQuoteDetails.Length then
                        Mui.divider []
                  ]
                )
                |> List.concat
              ]
            ]
          ]
      ]
      Mui.grid [
        grid.item true
        grid.children [
          Mui.typography [
            typography.variant.h5
            typography.children "Orders in process and recent history"
          ]
        ]
      ]
      Mui.grid [
        grid.item true
        grid.children [
          if inputProps.orderInfos.SupplyOrderDetails.Length = 0
          then
            Mui.typography [
              typography.variant.body2
              typography.children "No orders found."
            ]
          else
            viewOrderDetails {| token = inputProps.token; equipmentNumber = inputProps.equipmentNumber; orderDetails = inputProps.orderInfos.SupplyOrderDetails; customerContactName = inputProps.customerContactName; customerContactEmail = inputProps.customerContactEmail; |}
        ]
      ]
    ]
  ]
)